System.register(["./dyn-index.js", "./dyn-embla.js"], function(exports, module) {
  "use strict";
  var reactExports, EmblaCarousel;
  return {
    setters: [(module2) => {
      reactExports = module2.r;
    }, (module2) => {
      EmblaCarousel = module2.E;
    }],
    execute: function() {
      exports("u", useEmblaCarousel);
      function isObject(subject) {
        return Object.prototype.toString.call(subject) === "[object Object]";
      }
      function isRecord(subject) {
        return isObject(subject) || Array.isArray(subject);
      }
      function canUseDOM() {
        return !!(typeof window !== "undefined" && window.document && window.document.createElement);
      }
      function areOptionsEqual(optionsA, optionsB) {
        const optionsAKeys = Object.keys(optionsA);
        const optionsBKeys = Object.keys(optionsB);
        if (optionsAKeys.length !== optionsBKeys.length) return false;
        const breakpointsA = JSON.stringify(Object.keys(optionsA.breakpoints || {}));
        const breakpointsB = JSON.stringify(Object.keys(optionsB.breakpoints || {}));
        if (breakpointsA !== breakpointsB) return false;
        return optionsAKeys.every((key) => {
          const valueA = optionsA[key];
          const valueB = optionsB[key];
          if (typeof valueA === "function") return `${valueA}` === `${valueB}`;
          if (!isRecord(valueA) || !isRecord(valueB)) return valueA === valueB;
          return areOptionsEqual(valueA, valueB);
        });
      }
      function sortAndMapPluginToOptions(plugins) {
        return plugins.concat().sort((a, b) => a.name > b.name ? 1 : -1).map((plugin) => plugin.options);
      }
      function arePluginsEqual(pluginsA, pluginsB) {
        if (pluginsA.length !== pluginsB.length) return false;
        const optionsA = sortAndMapPluginToOptions(pluginsA);
        const optionsB = sortAndMapPluginToOptions(pluginsB);
        return optionsA.every((optionA, index) => {
          const optionB = optionsB[index];
          return areOptionsEqual(optionA, optionB);
        });
      }
      function useEmblaCarousel(options = {}, plugins = []) {
        const storedOptions = reactExports.useRef(options);
        const storedPlugins = reactExports.useRef(plugins);
        const [emblaApi, setEmblaApi] = reactExports.useState();
        const [viewport, setViewport] = reactExports.useState();
        const reInit = reactExports.useCallback(() => {
          if (emblaApi) emblaApi.reInit(storedOptions.current, storedPlugins.current);
        }, [emblaApi]);
        reactExports.useEffect(() => {
          if (areOptionsEqual(storedOptions.current, options)) return;
          storedOptions.current = options;
          reInit();
        }, [options, reInit]);
        reactExports.useEffect(() => {
          if (arePluginsEqual(storedPlugins.current, plugins)) return;
          storedPlugins.current = plugins;
          reInit();
        }, [plugins, reInit]);
        reactExports.useEffect(() => {
          if (canUseDOM() && viewport) {
            EmblaCarousel.globalOptions = useEmblaCarousel.globalOptions;
            const newEmblaApi = EmblaCarousel(viewport, storedOptions.current, storedPlugins.current);
            setEmblaApi(newEmblaApi);
            return () => newEmblaApi.destroy();
          } else {
            setEmblaApi(void 0);
          }
        }, [viewport, setEmblaApi]);
        return [setViewport, emblaApi];
      }
      useEmblaCarousel.globalOptions = void 0;
    }
  };
});
